'use client';

import Sidebar from './Sidebar';
import KanbanBoard from './KanbanBoard';
import { useProject } from '@/contexts/ProjectContext';

export default function ProjectLayout() {
  const { selectedProject } = useProject();

  if (!selectedProject) {
    return (
      <div className="flex-1 p-6 flex items-center justify-center">
        <div className="text-gray-400 text-sm">Select a project to view tasks</div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 overflow-hidden min-h-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <Sidebar />
      <KanbanBoard />
    </div>
  );
}



